import { companyDetailsConstants } from "../../_constants";
import axiosInstance from "../../../_helpers/axiosInstance";
import config from "../../../_config/config";


export const get_company_details_by_id_action =
  (id) => async (dispatch) => {
    dispatch({
      type: companyDetailsConstants.COMPANY_DETAILS_BY_ID_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.common.companyOverview.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: companyDetailsConstants.COMPANY_DETAILS_BY_ID_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: companyDetailsConstants.COMPANY_DETAILS_BY_ID_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

  export const get_company_list_detail_action  =
  (page) => async (dispatch) => {
    dispatch({
      type: companyDetailsConstants.COMPANY_LIST_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        `${config.common.companiesList}?page=${page ? page : 1}`
      );
      if (response.status) {
        dispatch({
          type: companyDetailsConstants.COMPANY_LIST_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: companyDetailsConstants.COMPANY_LIST_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

  export const get_company_jobs_lists_action =
  (id) => async (dispatch) => {
    dispatch({
      type: companyDetailsConstants.COMPANY_JOBS_LIST_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.common.companyJobsList.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: companyDetailsConstants.COMPANY_JOBS_LIST_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: companyDetailsConstants.COMPANY_JOBS_LIST_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };